<template>
  <div class="forgotpassword container">
    <img class="logo" alt="lts logo" src="../assets/logo.png" />
    <div class="forgotpassword-card">
      <div class="forgotpassword-card-header">LTS Forgotten Password</div>
      <div v-if="!credentialsSent" class="forgotpassword-card-body">
        <form @submit.prevent="sendLoginCredentials">
          <div v-show="error" class="error">{{ error }}</div>
          <div class="mb-2 heading-message">
            Please enter either your <span class="text-bold">Username</span> or <span class="text-bold">Email Address</span> in the textbox below and then click on the <span class="text-bold">Send Login Credentials</span> button.
          </div>
          <div class="mb-3">
            <label for="username">Username / Email Address</label>
            <input id="username" v-model="username" class="textbox mt-1" type="text" />
            <small v-show="username_invalid" class="required">Please enter a username</small>
          </div>
          <input v-show="!isSearchingCredentials" type="submit" value="Send Login Credentials" class="btn btn-forgotpassword" />
          <Loader v-show="isSearchingCredentials" class="loader"></Loader>
        </form>
      </div>
      <div v-if="credentialsSent" class="forgotpassword-card-body">
        <form @submit.prevent="redirectToHomepage">
          <div class="mb-2 heading-message">
            Your login credentials has been sent. If you did not receive your login credentials, please contact LTS Support at <span class="text-bold">support@ltsystems.co.za</span>.
          </div>
          <input type="submit" value="Ok" class="btn btn-forgotpassword" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Loader from "@/components/Loader.vue";
import axios from "axios";

export default {
  name: "Login",
  components: {
    Loader
  },
  data: () => {
    return {
      isSearchingCredentials: false,
      username: "",
      username_invalid: false,
      error: "",
      credentialsSent: false
    };
  },
  methods: {
    sendLoginCredentials: function() {
      this.isSearchingCredentials = true;
      this.error = "";

      // Validation
      this.username.trim().length > 0
        ? (this.username_invalid = false)
        : (this.username_invalid = true);

      if (this.username_invalid) {
        this.isSearchingCredentials = false;
        return;
      }

      // Call the login api
      axios
        .post("/users/forgotpassword", { username: this.username })
        .then(() => {
          this.credentialsSent = true;
        })
        .catch(() => {
            this.error = "Internal error occured. Please contact LTS support.";
        })
        .finally(() => {
            this.isSearchingCredentials = false;
        });
    },
    redirectToHomepage: function() {
        window.location.replace("http://www.ltsystems.co.za");
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.forgotpassword {
  max-width: 500px;
  margin: 0 auto;
}

.forgotpassword-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  border: 1px solid #d3d3d3;
}

.forgotpassword-card-header {
  font-weight: bold;
  padding: 1.5rem;
  color: white;
  background: $primary-color;
}

.forgotpassword-card-body {
  padding: 2rem;
}

.btn-forgotpassword {
  display: block;
  background: $primary-color;
  color: $white-color;
  font-weight: bold;
  width: 50%;
  margin: 0 auto;

  &:hover {
    background: #5e85d8;
  }
}

.logo {
  display: block;
  width: 100px;
  margin: 50px auto;
}

.error {
  color: $danger-color;
  text-align: center;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  padding: 0.5rem;
  border: 1px solid $danger-color;
  border-radius: 3px;
}

.loader {
  width: 4rem;
  margin: 0 auto;
}

.required {
  display: block;
  color: $danger-color;
}

.heading-message {
    text-align: center;
    color: #5e5e5e;
    font-size: 0.9rem;

    span {
        color: $primary-color;
    }
}
</style>
